/* eslint-disable camelcase */
import * as z from 'zod'

export const schema = z.object({
  bookedLocation: z
    .string({ required_error: 'This field is required' })
    .min(1, { message: 'Please enter a valid name' }),
})
